<template>
  <header
    class="
      w-full
      h-50
      sm:h-74
      bg-mobile-light
      dark:bg-mobile-dark
      sm:bg-desktop-light
      sm:dark:bg-desktop-dark
      bg-cover bg-no-repeat
      transition-all
      duration-300
    "
  ></header>
</template>
<script>
export default {
  name: "Header",
};
</script>